import React, { useRef, useState, useEffect } from 'react'
import { trans } from '../../../../_providers/Translation'
import DateRange from '@/components/partials/DateRange'
import Dropdown from '@/components/partials/Dropdown'
import { Slider } from '@mui/material'

const PRICE_MIN = 0
const PRICE_MAX = 10000

function Filter(props) {
    const categoryDropdownRef = useRef(null)
    const clientDropdownRef = useRef(null)

    const [priceRange, setPriceRange] = useState([PRICE_MIN, PRICE_MAX])

    // Keep the slider in sync when filters are cleared/updated from outside
    useEffect(() => {
        setPriceRange([
            props.filter.price_min !== undefined && props.filter.price_min !== ''
                ? Number(props.filter.price_min)
                : PRICE_MIN,
            props.filter.price_max !== undefined && props.filter.price_max !== ''
                ? Number(props.filter.price_max)
                : PRICE_MAX,
        ])
    }, [props.filter.price_min, props.filter.price_max])

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleSelectMobileFilter = e => {
        let selectedValue = e.target.value
        let fields = [...document.querySelectorAll('.filter-standard .col')]
        fields.map(field => {
            if (field.getAttribute('data-id') == selectedValue) field.style.display = 'flex'
            else if (field.getAttribute('data-id')) field.style.display = 'none'
        })
    }

    const handleClearFilters = () => {
        props.handleSearch('start_date', '')
        props.handleSearch('end_date', '')
        props.handleSearch('search', '')
        props.handleSearch('type_id', '')
        props.handleSearch('category_id', '')
        categoryDropdownRef.current.reset()
        props.handleSearch('customer_id', '')
        clientDropdownRef.current.reset()
        props.handleSearch('price_min', '')
        props.handleSearch('price_max', '')
        setPriceRange([PRICE_MIN, PRICE_MAX])
    }

    // Update local slider state on drag (no request yet)
    const handlePriceChange = (e, value) => {
        setPriceRange(value)
    }

    // Commit the price range once the user stops dragging
    const handlePriceChangeCommitted = (e, value) => {
        props.handleSearch('price_min', value[0] > PRICE_MIN ? value[0] : '')
        props.handleSearch('price_max', value[1] < PRICE_MAX ? value[1] : '')
    }

    const handleCategory = data => {

        let val = data.id || ''

        if (data.id || data.name == '') {
            props.handleSearch('category_id', val)
        }

    }


    const handleCustomer = data => {

        let val = data.id || ''

        if (data.id || data.name == '') {
            props.handleSearch('customer_id', val)
        }

    }


    return (
        <form className="filter-standard">
            <div className="col" data-id="3">
                <input
                    type="search"
                    name="search"
                    placeholder={trans('random.clientDocNo')}
                    className="field-big"
                    value={props.filter.search}
                    onChange={handleSearch}
                />
            </div>
            <div className="col select-filter-col">
                <label>
                    {trans('filters.filterBy')}
                </label>
                <select onChange={handleSelectMobileFilter}>
                    <option value="1">
                        {trans('filters.startDate')}
                    </option>
                    <option value="2">
                        {trans('filters.endDate')}
                    </option>
                    <option value="3">
                        {trans('filters.search')}
                    </option>
                </select>
            </div>

            <div className="col" data-id="1">
                <select
                    name="type_id"
                    value={props.filter.type_id || ''}
                    onChange={handleSearch}
                >
                    <option value="">{trans('invoice.type')}</option>
                    <option value={1}>
                        {trans('invoice.proforma')}
                    </option>
                    <option value={2}>
                        {trans('invoice.invoice')}
                    </option>
                </select>
            </div>

            <div className="col" data-id="2">
                <select
                    name="status"
                    value={props.filter.status || ''}
                    onChange={handleSearch}
                >
                    <option value="all">{trans('labels.status')}</option>
                    <option value="paid">{trans('tabs.paid')}</option>
                    <option value="unpaid">{trans('tabs.unpaid')}</option>
                    <option value="awaiting">{trans('tabs.awaitingPayment')}</option>
                </select>
            </div>

            <div className="col" data-id="3">
                <Dropdown
                    ref={categoryDropdownRef}
                    inputIdValue={Number(props.filter.customer_id)}
                    url="customers/with-invoices"
                    renderText={data => {
                        return data.full_name
                    }}
                    onChange={data => {
                        handleCustomer(data)
                    }}
                    inputPlaceholder={trans('labels.client')}
                />
            </div>

            <div className="col" data-id="4">
                <Dropdown
                    ref={clientDropdownRef}
                    inputIdValue={Number(props.filter.category_id)}
                    url="appliances/categories/all"
                    renderText={data => {
                        return data.name
                    }}
                    onChange={data => {
                        handleCategory(data)
                    }}
                    inputPlaceholder={trans('labels.category')}
                />
            </div>


            <div className="col" data-id="5">
                <div className="row"
                    style={{
                        backgroundColor: '#f8f8ff',
                        borderRadius: '20px',
                        padding: '5px',
                        border: '1px solid #e0e5f2',
                        height: '40px'
                    }}
                >
                    <div
                        className="col"
                        data-id="6"
                        style={{
                            maxWidth: '120px'
                        }}
                    >
                        <input
                            type="number"
                            name="min_price"
                            placeholder={trans('labels.priceFrom')}
                            className="field-big"
                            value={props.filter.min_price}
                            onChange={handleSearch}
                        />

                        {/* <div className="price-range">
                    <span>
                        {`${trans('labels.price')}: ${priceRange[0]} - ${priceRange[1]}`}
                    </span>
                    <Slider
                        value={priceRange}
                        min={PRICE_MIN}
                        max={PRICE_MAX}
                        step={50}
                        valueLabelDisplay="auto"
                        onChange={handlePriceChange}
                        onChangeCommitted={handlePriceChangeCommitted}
                        getAriaLabel={() => trans('labels.price')}
                        size='small'
                    />
                </div> */}
                    </div>

                    <div
                        className="col"
                        data-id="6"
                        style={{
                            maxWidth: '120px'
                        }}
                    >
                        <input
                            type="number"
                            name="max_price"
                            className="field-big"
                            placeholder={trans('labels.priceTo')}
                            value={props.filter.max_price}
                            onChange={handleSearch}
                        />
                    </div>
                </div>
            </div>
            <div className="col" data-id="5">
                <DateRange
                    startDate={props.filter.start_date}
                    endDate={props.filter.end_date}
                    onStartDateChange={(date) => {
                        props.handleSearch('start_date', date)
                    }} onEndDateChange={(date) => {
                        props.handleSearch('end_date', date)
                    }}
                />
            </div>

            <div className='col'>
                <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                    {trans('buttons.clearFilter')}
                </button>
            </div>
        </form>
    )
}

export default React.memo(Filter, (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next)
})